export const TEMPORAL_DIM_ORDER_SELECTOR_VALUE_ASC = "ASC";
export const TEMPORAL_DIM_ORDER_SELECTOR_VALUE_DESC = "DESC";

export const TEMPORAL_DIM_ORDER_SELECTOR_VALUE_UNSET = "UNSET";
